export const buildFormData = (
  formData: FormData,
  data: any,
  parentKey?: string,
) => {
  if (data === null || data === undefined) return;

  if (data instanceof File) {
    if (parentKey) {
      // console.log("parentkey:", parentKey);
      formData.append(parentKey, data);
    }
  } else if (Array.isArray(data)) {
    data.forEach((value, index) => {
      buildFormData(formData, value, `${parentKey}[${index}]`);
    });
  } else if (typeof data === "object") {
    Object.keys(data).forEach((key) => {
      const value = data[key];
      const newKey = parentKey ? `${parentKey}[${key}]` : key;
      buildFormData(formData, value, newKey);
    });
  } else {
    formData.append(parentKey!, String(data));
  }
};
